import { TabView, TabPanel } from 'primereact/tabview';
import ProgressTableClass from './ProgressTableClass';
import { useAppSelector } from '../../redux/hooks';
import { selectedCsvProcess } from '../../redux/reducers/csvProcessSlice';
import ProgressStudentTablesContainer from './ProgressStudentTablesContainer';
import { FC } from 'react';

const ProgressTables: FC = () => {
  const isCsvProcessing = useAppSelector(selectedCsvProcess);
  return (
    <div className="nc_block w-full mb-8">
      <TabView id="tab-view" className="col-12 nc_tabView">
        <TabPanel
          header={
            <div id="progressStudentsTab" style={{ padding: '1rem' }}>
              Students
            </div>
          }
          disabled={isCsvProcessing}
          className="nc_tabPanel"
        >
          <ProgressStudentTablesContainer />
        </TabPanel>
        <TabPanel
          header={
            <div id="progressClassTab" style={{ padding: '1rem' }}>
              Classes
            </div>
          }
          disabled={isCsvProcessing}
          className="nc_tabPanel"
        >
          <ProgressTableClass />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default ProgressTables;
